import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import AdminLogin from "./Views/Auth/AdminLogin/AdminLogin.js";
import Email from "./Views/Auth/ForgetPassword/Email/email.js";
import ConfirmCode from "./Views/Auth/ForgetPassword/confirmationCode/confirmationCode.js";
import NewPassword from "./Views/Auth/ForgetPassword/resetPassword/resetPassword.js";
import Layout from "./Components/DefaultyLayout/defaultLayout.js";
import Payment from "./payment.js";

import cookie from "react-cookies";
import { MyTicket_PATH, MyTicket_LANGUAGE } from "./AppConfig";
import MapPage from "./Template/Version_one/Map/googleMap";
import "@progress/kendo-theme-default/dist/all.css";
class App extends Component {
  render() {
    if (cookie.load(MyTicket_LANGUAGE) === undefined) {
      cookie.save(MyTicket_LANGUAGE, JSON.stringify("ar"), {
        path: MyTicket_PATH,
      });
    }
    if (this.props.lang === "ar") {
      document.body.style.direction = "rtl";
      document.body.style.textAlign = "right";
    } else if (this.props.lang === "en") {
      document.body.style.direction = "ltr";
      document.body.style.textAlign = "left";
    }
    return (
      <BrowserRouter>
        <Switch>
          <Route
            path={`/MyTicket/payment/:id`}
            name="Payment Page"
            component={Payment}
          />
          <Route
            path="/MyTicket/admin-login"
            name="Admin Login Page"
            component={AdminLogin}
          />
          <Route
            exact
            path="/MyTicket/forgetpassword"
            name="Forget Password"
            component={Email}
          />
          <Route
            exact
            path="/MyTicket/ConfirmCode"
            name="ConfirmCode"
            component={ConfirmCode}
          />
          <Route
            exact
            path="/MyTicket/newPasswordPage"
            name="New Password"
            component={NewPassword}
          />
          <Route path="/" name="Home" component={Layout} />
        </Switch>
      </BrowserRouter>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.userInfo.language,
  };
};
export default connect(mapStateToProps, null)(App);
